import {
  GET_SAMPLE_DETAILS_PENDING,
  GET_SAMPLE_DETAILS_FULFILLED,
  GET_PRODUCT_DETAILS_PENDING,
  GET_PRODUCT_DETAILS_FULFILLED,
  GET_PRODUCT_DETAILS_FAILED,
  UPDATE_PRODUCT_LINE_CONFIGURATION,
  UPDATE_COLOR_SWATCHES,
  TOGGLE_PLCC_MODAL,
} from '../actions/actionTypes';

// Must be a pure function that requires the state
// and the action being dispatched.
const initialState = {
  currentProducts: {},
  productLinesConfigurations: {},
  currentSamples: [],
  isSamplesFulfilled: false,
  currentColorSwatches: {},
  currentOmsId: 0,
  currentSurfaceCodes: '',
  showPlccModal: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
  // NEVER mutate the state, always return a new state.

  case GET_PRODUCT_DETAILS_PENDING: {
    const { currentProducts, currentColorSwatches } = state;
    delete currentProducts[action.payload.omsId];
    delete currentColorSwatches[action.payload.omsId];

    return {
      ...state,
      currentProducts,
      getProductDeatilsStatus: 'PENDING',
    };
  }

  case GET_PRODUCT_DETAILS_FULFILLED: {
    const { currentProducts, currentColorSwatches } = state;
    currentProducts[action.payload.omsId] = action.payload.response;
    currentColorSwatches[action.payload.omsId] = action.payload.colorSwatches;

    return {
      ...state,
      currentProducts,
      currentColorSwatches,
      currentOmsId: action.payload.omsId,
      currentSurfaceCodes: action.payload.productSurfaceCodes,
      getProductDeatilsStatus: 'FULFILLED',
    };
  }

  case GET_PRODUCT_DETAILS_FAILED: {
    return {
      ...state,
      getProductDeatilsStatus: 'FAILED',
    };
  }

  case GET_SAMPLE_DETAILS_PENDING: {
    const currentSamples = { ...state.currentSamples };

    return {
      ...state,
      currentSamples,
      isSamplesFulfilled: false,
    };
  }

  case GET_SAMPLE_DETAILS_FULFILLED: {
    let currentSamples = { ...state.currentSamples };
    currentSamples = action.payload.response;

    return {
      ...state,
      currentSamples,
      isSamplesFulfilled: true,
    };
  }

  case UPDATE_PRODUCT_LINE_CONFIGURATION: {
    const productLinesConfigurations = { ...state.productLinesConfigurations };
    productLinesConfigurations[action.payload.productLine] = action.payload.configurations;

    return {
      ...state,
      productLinesConfigurations,
    };
  }

  case UPDATE_COLOR_SWATCHES: {
    const { currentColorSwatches, currentOmsId } = state;
    if (!currentColorSwatches[currentOmsId]) {
      currentColorSwatches[currentOmsId] = [];
    }
    currentColorSwatches[currentOmsId] = action.payload;

    return {
      ...state,
      currentColorSwatches,
    };
  }

  case TOGGLE_PLCC_MODAL: {
    return {
      ...state,
      showPlccModal: action.payload.showModal,
    };
  }

  default:
    return state;
  }
};
